import { PageLoader, WithNavigation } from '@zeiss/lib-components';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { Outlet, useNavigate } from 'react-router-dom';

import { AccountMenu, Breadcrumbs, Footer } from 'src/components/layout';
import { PRODUCT_TITLE } from 'src/constants';
import { useGlobalEvaluations, useNavigationGroups } from 'src/hooks';

export const RootLayout = () => {
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation(['common']);
  const { isLoading } = useGlobalEvaluations();
  const navigate = useNavigate();
  const navigationGroups = useNavigationGroups();

  const goHome = () => navigate('/');

  /**
   * If the user is not yet authenticated render the `Outlet`. In case the
   * route uses `ProtectedRoute`, it will trigger the authentication redirect.
   */
  if (!isAuthenticated) {
    return <Outlet />;
  }

  /**
   * Dedicated loading screen while the evaluations are being fetched. This
   * prevents the app `RootLayout` skeleton to flash through.
   */
  if (isLoading) {
    return <PageLoader label={t('common:loadingFeedback.loading')} size="xl" />;
  }

  /**
   * Root
   *
   * Used for authorized users.
   *
   * Layout:
   *
   * ┌──────────────┐
   * │───┬──────────│
   * │   │          │
   * │   │    xx    │
   * │   │          │
   * │───┴──────────│
   * └──────────────┘
   */

  return (
    <WithNavigation
      accountMenu={<AccountMenu />}
      applicationTitle={PRODUCT_TITLE}
      footer={<Footer />}
      navigationGroups={navigationGroups}
      onLogoClick={goHome}
    >
      <Breadcrumbs />
      <Outlet />
    </WithNavigation>
  );
};
